export default [
  {
    code: 100,
    message: "پرداخت با موفقیت انجام شد",
    error: false,
    message_type: "success",
  },
  {
    code: 101,
    message: "این پرداخت قبلا اعتبار سنجی شده است",
    error: false,
    message_type: "warning",
  },
  {
    code: -51,
    message: "پرداخت ناموفق بود",
    error: true,
    message_type: "error",
  },
  {
    code: -52,
    message: "خطای غیر منتظره ای رخ داده است",
    error: true,
    message_type: "error",
  },
  {
    code: -54,
    message: "شناسه پرداخت نامعتبر است",
    error: true,
    message_type: "error",
  },
  {
    code: -55,
    message: "تراکنش مورد نظر یافت نشد",
    error: true,
    message_type: "error",
  },
];
